'use client'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'
import { Media } from '../components/Media/Media'
import React from 'react'
import RichText from '@onclicks/sharedcomponents/RichText'
import { CMSLink } from '../components/CMSLink'

export const CallToActionBlock: React.FC<CTABlockProps> = (props) => {
  const { links, richText, media } = props

  return (
    <div className="relative overflow-hidden rounded-2xl bg-[#f57c00] lg:mr-14">
      <div className="flex flex-col lg:flex-row">
        {media && (
          <div className="relative w-full h-64 lg:h-auto lg:w-[40%]">
            <Media fill imgClassName="object-cover w-full h-full" resource={media} priority />
          </div>
        )}

        <div className="flex flex-col justify-center p-4 w-full lg:w-[60%]">
          {richText && (
            <div className="mb-8">
              <RichText className="text-sm" data={richText} enableGutter={false} />
            </div>
          )}

          <div className="flex flex-wrap gap-4">
            {(links || []).map(({ link }, i) => {
              return <CMSLink key={i} {...link} className="px-8 py-3 rounded-full font-bold" />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
